export * from './LocaleLabel.js'
